import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

import { pageTransitions } from '../../animations/page-transitions';
import { LoadingSpinnerComponent } from '../utils/loading-spinner.component';

@Component({
	selector: 'copo-auction-offer-widget',
	templateUrl: './auction-widget.component.html',
	styleUrl: './auction-widget.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,

	imports: [NgIf, TranslateModule, MatButtonModule, RouterLink, MatIconModule, LoadingSpinnerComponent]
})
export class AuctionWidgetComponent implements OnInit {
	@Input() headerLabel!: string;
	@Input() btnLabel!: string;
	@Input() btnRouterLink!: string;
	offerDraftSubscription?: Subscription;
	isLoading = true;

	ngOnInit() {
		this.isLoading = false;
	}
}
